<template>
  <!-- 横屏 -->
  <horizontalScreen class="v-game-course"> 
    <!-- <scaleWrap> -->
      <div class="home">
          <img class="leaf" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/top_leaf.png"/>
          <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)" :id="`word${index}`" class="word" v-for="(word, index) in showWordList" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index)">
                <div class="icon-img" :style="{backgroundImage: 'url(' + word.icon + ')'}"> 
                </div> 
              </div>
            </div>
          </div>
          <!-- <div class="word-container">
            <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :id="`word${index+3}`" class="word" v-for="(word, index) in showWordList.slice(3, 6)" :key="word.name">
              <img class="flower" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/anime/type0/0.png"/>
              <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+3)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
            </div>
          </div>
         -->
        <!-- <div class="word-container">
          <div @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :id="`word${index+6}`" class="word" v-for="(word, index) in showWordList.slice(6, 9)" :key="word.name">
            <img src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/anime/type0/0.png"/>
            <div v-show="word.showIcon" class="icon" @click.stop.prevent="word.clicked ? null : wordClickHandler($event, word, index+6)" :style="{backgroundImage: 'url(' + word.icon + ')'}"></div>
          </div>
        </div> -->
        <img id="person" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/walk/0.png">
        <!-- <img id="partner" src="@/assets/game6-4/clap/0.png"> -->
        <img class="logo" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/logo.png"/>
        <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
           <img @click="backHandler" class="back" src="@/assets/back.png"/>
           <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
           <img @click="startHandler" class="voice" src="@/assets/voice.png"/>
        </div>
        <!-- <div class="sound-box-bottom"> -->
           <!-- <img @click="backHandler" class="back" src="@/assets/back.png"/> -->
           <!-- <img @click="reverseHandler" class="reverse" src="@/assets/reverse.png"/> -->
           <!-- <img @click.stop.prevent="startHandler" class="voice" src="@/assets/voice.png"/> -->
        <!-- </div> -->
        <audio id="myAudio" preload="auto"></audio>
        <audio id="failAudio" preload="auto">
          <source :src="this.failAudio">
        </audio>
        <audio id="walkAudio" preload="auto">
          <source :src="this.walkAudio">
        </audio>
        <audio id="tiaoAudio" preload="auto">
          <source :src="this.tiaoAudio">
        </audio>
        <audio id="huangAudio" preload="auto">
          <source :src="this.huangAudio">
        </audio>
        <audio id="dropAudio" preload="auto">
          <source :src="this.dropAudio">
        </audio>
        <audio id="xiaoAudio" preload="auto">
          <source :src="this.xiaoAudio">
        </audio>
        <audio id="successAudio" preload="auto">
          <source :src="this.successAudio">
        </audio>
        <Overlay class="mask-dialog" :show="showStartGameIcon">
          <img class="overlay-bg" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/bg.png"/>
          <div class="sound-box-top" :style="{right: height < 700 ? '10px' : null}">
            <img @click="backHandler" class="back" src="@/assets/back.png"/>
            <!-- <img @click.stop.prevent="reverseHandler" class="reverse" src="@/assets/reverse.png"/>
            <img @click="startHandler" class="voice" src="@/assets/voice.png"/> -->
          </div>
          <div class="mask-title">{{index}} {{gameName}}</div>
          <img @click="startGameHandler(true)" class="start" src="https://image.yuanyuanwenhua.com/literacy/static/img/allGame/btn-start.png"/>
        </Overlay>
      </div>
    <!-- </scaleWrap> -->
  </horizontalScreen>
</template>
<script>
import anime from 'animejs/lib/anime.es.js'
import horizontalScreen from '@/components/horizontal-screen'
// import scaleWrap from '@/components/scale-wrap'
import {shuffle, isEmpty, cloneDeep} from 'lodash'
import { Overlay } from 'vant'
import mixin from '../mixin'
import {Howl} from 'howler'
import {isIOS} from '@/utils/env'

export default {
  name: 'GameCourse',
  mixins: [mixin],
  components: {
    // , scaleWrap
    horizontalScreen, Overlay
  },
  created () {
    this.walkAudioVoice = new Howl({
      src: [this.walkAudio],
      html5: isIOS
    });
    this.tiaoAudioVoice = new Howl({
      src: [this.tiaoAudio],
      html5: isIOS
    });
    this.huangAudioVoice = new Howl({
      src: [this.huangAudio],
      html5: isIOS
    });
    this.dropAudioVoice = new Howl({
      src: [this.dropAudio],
      html5: isIOS
    });
    this.xiaoAudioVoice = new Howl({
      src: [this.xiaoAudio],
      html5: isIOS
    });
    this.successAudioVoice = new Howl({
      src: [this.successAudio],
      html5: isIOS
    });
  },
  beforeDestroy () {
    this.walkAudioVoice.pause()
    this.tiaoAudioVoice.pause()
    this.huangAudioVoice.pause()
    this.dropAudioVoice.pause()
    this.xiaoAudioVoice.pause()
    this.successAudioVoice.pause()
  },
  data() {
    return {
      walkAudioVoice: null,
      tiaoAudioVoice: null,
      huangAudioVoice: null,
      dropAudioVoice: null,
      xiaoAudioVoice: null,
      successAudioVoice: null,
      personTarget: {
        left: null,
        bottom: null,
      },
      index: this.$route.query.index,
      id: this.$route.query.id,
      gameName: null,
      clickAudio: require(`@/assets/sounds/click.mp3`),
      failAudio: require(`@/assets/sounds/fail.mp3`),
      walkAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/sounds/walk.mp3`,
      tiaoAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/sounds/tiao.mp3`,
      huangAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/sounds/huang_old.mp3`,
      dropAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/sounds/drop.mp3`,
      xiaoAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/sounds/xiao.mp3`,
      successAudio: `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/sounds/suc.mp3`,
      boardImgLength: 2, // 箱子
      workImgLength: 18, // 小人走路动画
      digImgLength: 115 // 小人挖宝动画
    }
  },
  watch: {
    isWalk(val) {
      this.$nextTick(() => {
        const person = document.getElementById('person')
        if (val) {
          person.style.zIndex = 60
        } else {
          console.log('person.style.left', person.style.left, this.personTarget.left)
          if (!person.style.left || person.style.left.slice(0,-2) == this.personTarget.left) {
            person.style.zIndex = 40
          }
        }
      })
    }
  },
  mounted() {
    this.initPersonLocation()
  },
  methods: {
    isEmpty,
    initPersonLocation(){
      const personTarget = document.getElementById('person')
      if (this.isVertical) {
        this.personTarget.left = personTarget.offsetLeft
        this.personTarget.bottom = document.body.clientWidth - personTarget.offsetTop - personTarget.offsetHeight
      } else {
        this.personTarget.left = personTarget.offsetLeft
        this.personTarget.bottom = document.body.clientHeight - personTarget.offsetTop - personTarget.offsetHeight
      }
     
    },
    // 走路动画
    personWalkGifHandler () {
      clearInterval(this.timerWalk)
      this.timerWalk = null
      let i = 0
      const person = document.getElementById('person')
      this.timerWalk = setInterval(() => {
        this.isWalk = true
        // 前面17张走路
        if (i>=this.workImgLength) {
          clearInterval(this.timerWalk)
          this.timerWalk = null
          // this.isWalk = false
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/walk/${i}.png`
        }
      }, 80)
    },
    // 挖宝动画
    personDigGifHandler (word) {
      clearInterval(this.timerDig)
      this.timerDig = null
      let i = this.workImgLength
      const flowerTarget = document.querySelector(`#${word} .flower`)
      const person = document.getElementById('person')
      this.timerDig = setInterval(() => {
        this.isWalk = true
        if (i === this.workImgLength) {
          // document.getElementById('tiaoAudio').play()
          this.tiaoAudioVoice.play()
        }
        if (i== this.workImgLength+1) {
          flowerTarget.style.display = 'none'
        }
        if (i === 28) {
          // document.getElementById('huangAudio').play()
          this.huangAudioVoice.play()
        }
        if (i === 72) {
          // document.getElementById('dropAudio').play()
          this.dropAudioVoice.play()
        }
        if (i === 88) {
          // document.getElementById('xiaoAudio').play()
          this.xiaoAudioVoice.play()
        }
        if (i === 98) {
          // document.getElementById('successAudio').play()
          this.successAudioVoice.play()
        }
          
        if (i >= this.digImgLength -1) {
          clearInterval(this.timerDig)
          this.timerDig = null
          // this.isWalk = false
          setTimeout(() => {
            person.style.right = null
            person.style.top = null
            person.style.transform = 'none'
            person.style.left = `${this.personTarget.left}px`
            person.style.bottom = `${this.personTarget.bottom}px`
            person.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/walk/${0}.png`
            this.getData(true)
          }, 1500)
        } else {
          i=i+1
          person.src =`https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/walk/${i}.png`
        }
      }, 80)
    },
    // 打乱文字排序
    async reverseHandler() {
      if (!this.isWalk){
        clearInterval(this.timerWalk)
        this.timerWalk = null
        clearInterval(this.timerSigh)
        this.timerSigh = null
        clearInterval(this.timerClap)
        this.timerClap = null
        clearInterval(this.timerDig)
        this.timerDig = null
        clearInterval(this.timerBoard)
        this.timerBoard = null
        const person = document.getElementById('person')
        person.style.right = null
        person.style.top = null
        person.style.left = `${this.personTarget.left}px`
        person.style.bottom = `${this.personTarget.bottom}px`
        

        this.audioList = []
        await this.initData()
        
        this.showWordList = shuffle(this.InitWordList)
        this.wordList = cloneDeep(this.showWordList)
        this.$set(this, 'showWordList', shuffle(this.InitWordList)) 
        this.$set(this, 'wordList', cloneDeep(this.showWordList)) 
        for(let i =0;i<this.InitWordList.length;i++) {
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/anime/type0/${0}.png`
        }
         for(let i =0;i<this.showWordList.length;i++) {
          this.showWordList[i].clicked = false
          const word = document.getElementById(`word${i}`)
          const flowerTarget = document.querySelector(`#word${i} .flower`)
          const wordTarget = document.querySelector(`#word${i} div`)
          word.style.visibility = 'visible'
          wordTarget.style.display = 'block'
          flowerTarget.style.display = 'block'
          flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/anime/type0/${0}.png`

        }
        // 一切重新开始
        this.getData()
        this.startGameHandler()
      }
    },
    // 字点击
    wordClickHandler(event, word, index) {
      console.log('word', word, event.target.className)
      console.log('isWalk', this.isWalk)

      if (this.isWalk) return

      let parentNode = event.target.parentElement
      if (event.target.className == 'icon-img') {
        parentNode = event.target.parentElement.parentElement
      } else {
        parentNode = event.target.parentElement
      }
      anime({
        targets: parentNode,
        scale: [
          { value: 1, duration: 100 },
          { value: 1.1, duration: 100 },
          { value: 1, duration: 100 }
        ],
        complete: () => {
          parentNode.style.transform = 'none'
        }
      });
      
      if (this.currentWord.name !== word.name) {
        this.playClickAudio()
        this.playFailAudio()
        return false
      }
      
      this.showWordList[index].clicked = true

      this.playClickAudio()
      // document.getElementById('walkAudio').play()
      this.walkAudioVoice.play()

      const target = document.getElementById(`word${index}`)
      const person = document.getElementById('person')
      
      this.personWalkGifHandler()
      // 文字消失
      const wordTarget = document.querySelector(`#word${index} div`)
      wordTarget.style.display = 'none'
      // 变换成第一个花苞
      const flowerTarget = document.querySelector(`#word${index} .flower`)
      flowerTarget.src = `https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/anime/type0/${1}.png`

      
      this.animation = anime({
        targets: person,
        left: `${target.offsetLeft}px`,
        bottom: `${this.isVertical ? document.body.clientWidth - target.offsetTop - target.offsetHeight/2 - person.offsetHeight/2 : document.body.clientHeight - target.offsetTop - target.offsetHeight/2 - person.offsetHeight/2}px`,
        
        easing: 'easeInOutQuad',
        duration: (this.workImgLength-1)*80, // 走路多久到达的时间 走路的动作乘以时间
        complete: () => {
          // target.innerHTML = '到达'
          clearInterval(this.timerWalk)
          this.personDigGifHandler(`word${index}`, index)
          // this.boardGifHandler(`word${index}`, index)
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.v-game-course{
  // font-family: 'Alibaba-PuHuiTi-Bold';
  // font-family: 'FZHuPo-M04S';
audio {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: -1;
}
.mask-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  // background: url(~https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  .overlay-bg {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -1;
  }
   .mask-title {
    border: solid 3px #5f0001;
    color: #5f0001;
    font-size: 50px;
    padding: 20px 0;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    width: 76%;
    margin: 5% auto;
  }
  .start {
    display: block;
    width: 124px;
  }
  .btn-restart {
    width: 223.33px;
  }
}

.home {
  height: 100%;
  width: 100%;
  background: url(https://image.yuanyuanwenhua.com/literacy/static/img/allGame/game6-4/bg.png) center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
}
.leaf {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -10px;
  height: auto;
  width: 80%;
  z-index: 70;
}
// .logo {
//   width: 12px;
//   left: 5px;
//   top: 10PX;
//   position: fixed;
// }
.sound-box-top {
  width: 46px;
  right: 20px;
  top: 10PX;
  z-index: 990;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.sound-box-bottom {
  z-index: 990;
  width: 46px;
  right: 5px;
  bottom: 5px;
  position: fixed;
  > img {
    display: block;
    width: 46px;
    & + img {
      margin-top: 10px;
    }
  }
}
.word-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  height: 28%;
  width: 200%;
  align-items: flex-start;
  margin-left: -51%;
  .word {
    transform-origin: center;
    width: 360px;
    height: 411.27px;
    font-size: 30px;
    // font-weight: bolder;
    position: relative;
    .light {
      display: none;
      position: absolute;
      width: 70%;
      left: 18%;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 99;
    }
    .flower {
      position: absolute; 
      width: 100%;
      // width: 319.5px;
      // height: 416.5px;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    & + .word {
      margin-left: -270px;
    }
    .icon {
      z-index: 60;
      display: block;
      width: 25%;
      height: 22%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 52%;
      transform: translateX(-50%);
      bottom: 53%;
    }
    .icon-img {
      z-index: 60;
      display: block;
      width: 74px;
      height: 74px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 12%;
    }
  }
  #word0 {
    margin-top: -10px
  }
  #word1 {
    margin-top: -5px;
  }
  #word2 {
    margin-top: -35px;
  }
  #word3 {
    margin-top: -45px;
  }
  #word4 {
    margin-top: -20px;
  }
  #word5 {
    margin-top: -10px;
  }
}
#person {
  width: 360px;
  // height: 353.63px;
  position: fixed;
  left: -10%;
  bottom: 0px;
  z-index: 40;
}
}
</style>